/* kitsters-refund-policy.js - smooth-scroll + scroll-spy for the sticky
   "On this page" jump nav. The nav links and their target section ids are
   both rendered server-side, so this only wires behaviour. */
(function () {
  'use strict';

  function init() {
    var root = document.querySelector('.krf');
    if (!root) return;

    var nav = root.querySelector('[data-krf-nav]');
    if (!nav) return;

    var links = Array.prototype.slice.call(nav.querySelectorAll('[data-krf-nav-link]'));
    if (!links.length) return;

    var reduce = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    nav.addEventListener('click', function (e) {
      var a = e.target.closest('a');
      if (!a) return;
      var target = document.getElementById(a.getAttribute('href').slice(1));
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      if (history.replaceState) { history.replaceState(null, '', a.getAttribute('href')); }
    });

    if (!('IntersectionObserver' in window)) return;

    var targets = links
      .map(function (a) { return document.getElementById(a.getAttribute('data-krf-nav-link')); })
      .filter(Boolean);
    if (!targets.length) return;

    var visible = {};
    function setActive() {
      var activeId = null;
      for (var i = 0; i < targets.length; i++) {
        if (visible[targets[i].id]) { activeId = targets[i].id; break; }
      }
      if (!activeId) return;
      links.forEach(function (a) {
        a.classList.toggle('is-active', a.getAttribute('data-krf-nav-link') === activeId);
      });
    }

    var spy = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        visible[entry.target.id] = entry.isIntersecting;
      });
      setActive();
    }, { rootMargin: '-20% 0px -70% 0px' });

    targets.forEach(function (t) { spy.observe(t); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
